import React from "react";
import PropTypes from "prop-types";
import { RCL as useTranslation } from "../RCL";
// eslint-disable-next-line import/no-cycle
import { SignUpForm } from "./SignUpForm";

const SignUpFormConnector = ({ data, lang }) => (
	<SignUpForm
		id={data.id}
		lang={lang}
		labels={{
			title: useTranslation({ searchKey: "subscribe-to-our-newsletter" }),
			subtitle: useTranslation({
				searchKey: "sign-up-for-access-to-exclusive-sunwing-deals-promotional-offers",
			}),
			email: useTranslation({ searchKey: "email" }),
			gateway: useTranslation({ searchKey: "gateway" }),
			submit: useTranslation({ searchKey: "sign-up" }),
			unsubscribe: useTranslation({
				searchKey: "you-may-unsubscribe-at-any-time",
			}),
			successMessage: useTranslation({
				searchKey: "you-have-successfully-signed-up-to-become-a-sunwing-member",
			}),
			errorMessage: useTranslation({
				searchKey: "your-email-could-not-be-confirmed-please-try-again",
			}),
			emailValidation: useTranslation({
				searchKey: "please-enter-a-valid-email",
			}),
			gatewayValidation: useTranslation({
				searchKey: "please-select-a-gateway",
			}),
		}}
		links={[
			{
				text: useTranslation({ searchKey: "privacy-policy" }),
				url: useTranslation({ searchKey: "privacy-policy-link" }),
			},
			{
				text: useTranslation({ searchKey: "contact-us" }),
				url: useTranslation({ searchKey: "contact-us-link" }),
			},
		]}
	/>
);

SignUpFormConnector.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
	}).isRequired,
	lang: PropTypes.oneOf(["en", "fr"]),
};

SignUpFormConnector.defaultProps = {
	lang: "en",
};

export default SignUpFormConnector;
export { SignUpFormConnector };
